import { combineReducers } from 'redux';
import authReducer from './auth';

const rootReducer: any = combineReducers({
    auth: authReducer,
});

export default rootReducer;
